import React, { useState, useEffect } from "react";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/weatherWarning.scss";

// Bootstrap Components
import Container from "react-bootstrap/Container";

// icon
import { GiFire } from "react-icons/gi";
//import { GiFrostfire } from "react-icons/gi";
import { MdOutlineSevereCold } from "react-icons/md";
import { PiThermometerHotFill, PiThermometerColdFill } from "react-icons/pi";
import { RiWindyFill } from "react-icons/ri";
//import { FaCloudRain } from "react-icons/fa";
//import { IoRainy } from "react-icons/io5";
import { BsFillCloudRainHeavyFill } from "react-icons/bs";
import { MdLandslide } from "react-icons/md";
//import { BsTsunami } from "react-icons/bs";
import { FaHouseTsunami } from "react-icons/fa6";
import { AiFillThunderbolt } from "react-icons/ai";
// svg HKO icons
import TY01 from "../../../../resources/image/HKOsignals/TY01.svg";
import TY03 from "../../../../resources/image/HKOsignals/TY03.svg";
import TY08NW from "../../../../resources/image/HKOsignals/TY08NW.svg";
import TY08SW from "../../../../resources/image/HKOsignals/TY08SW.svg";
import TY08NE from "../../../../resources/image/HKOsignals/TY08NE.svg";
import TY08SE from "../../../../resources/image/HKOsignals/TY08SE.svg";
import TY09 from "../../../../resources/image/HKOsignals/TY09.svg";
import TY10 from "../../../../resources/image/HKOsignals/TY10.svg";
import NTF from "../../../../resources/image/HKOsignals/NTF.svg";
// END

// debug json
//import data from "../../../sources/weather.php.json";
import data_debug from "../../../../resources/weather.php__.json";
// END

import { getWeatherWarning } from "../../../service/apiHKOWeatherInfoService";

// HKO warning code to icon
function WarningIcon(warningCode: string) {
  switch (warningCode) {
    case "WFIREY":
      return (
        <GiFire
          key={warningCode}
          color="#FFB500"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "WFIRER":
      return (
        <GiFire
          key={warningCode}
          color="red"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "WFROST":
      return (
        <MdOutlineSevereCold
          key={warningCode}
          color="blue"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "WHOT":
      return (
        <PiThermometerHotFill
          key={warningCode}
          color="red"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "WCOLD":
      return (
        <PiThermometerColdFill
          key={warningCode}
          color="blue"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "WMSGNL":
      return (
        <RiWindyFill
          key={warningCode}
          color="gray"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    // case 'WTCPRE8':
    //     // pre-8
    //     console.log('WTCPRE8');
    //     break;
    case "WRAINA":
      return (
        <BsFillCloudRainHeavyFill
          key={warningCode}
          color="#FFBD00"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "WRAINR":
      return (
        <BsFillCloudRainHeavyFill
          key={warningCode}
          color="red"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "WRAINB":
      return (
        <BsFillCloudRainHeavyFill
          key={warningCode}
          color="black"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "WFNTSA":
      // 新北水浸
      return (
        <img
          key={warningCode}
          src={NTF}
          alt="NTF"
          style={{ width: 80, height: 80 }}
          className="warningAlertIcons"
        />
      );
    //break;
    case "WL":
      return (
        <MdLandslide
          key={warningCode}
          color="#946737"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "TC1":
      return (
        <img
          key={warningCode}
          src={TY01}
          alt="TY01"
          style={{ width: 80, height: 80 }}
          className="warningAlertIcons"
        />
      );
    case "TC3":
      return (
        <img
          key={warningCode}
          src={TY03}
          alt="TY03"
          style={{ width: 80, height: 80 }}
          className="warningAlertIcons"
        />
      );
    case "TC8NE":
      return (
        <img
          key={warningCode}
          src={TY08NE}
          alt="TY08NE"
          style={{ width: 80, height: 80 }}
          className="warningAlertIcons"
        />
      );
    case "TC8SE":
      return (
        <img
          key={warningCode}
          src={TY08SE}
          alt="TY08SE"
          style={{ width: 80, height: 80 }}
          className="warningAlertIcons"
        />
      );
    case "TC8SW":
      return (
        <img
          key={warningCode}
          src={TY08SW}
          alt="TY08SW"
          style={{ width: 80, height: 80 }}
          className="warningAlertIcons"
        />
      );
    case "TC8NW":
      return (
        <img
          key={warningCode}
          src={TY08NW}
          alt="TY08NW"
          style={{ width: 80, height: 80 }}
          className="warningAlertIcons"
        />
      );
    case "TC9":
      return (
        <img
          key={warningCode}
          src={TY09}
          alt="TY09"
          style={{ width: 80, height: 80 }}
          className="warningAlertIcons"
        />
      );
    case "TC10":
      return (
        <img
          key={warningCode}
          src={TY10}
          alt="TY10"
          style={{ width: 80, height: 80 }}
          className="warningAlertIcons"
        />
      );
    case "WTMW":
      return (
        <FaHouseTsunami
          key={warningCode}
          color="purple"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    case "WTS":
      return (
        <AiFillThunderbolt
          key={warningCode}
          color="#FFBD00"
          fontSize="4em"
          className="warningAlertIcons"
        />
      );
    default:
      break;
  }
}

function KeyFatch(keyFatchSource: Object): Array<string> {
  let requiredWarningCode: Array<string> = new Array<string>();

  const keys = Object.keys(keyFatchSource) as Array<string>;
  if (keys.length === 0) {
    return requiredWarningCode;
  }
  keys.forEach((key) => {
    let keyItem: any = keyFatchSource[key as keyof typeof keyFatchSource];

    if (keyItem.actionCode !== "CANCEL") {
      requiredWarningCode.push(keyItem.code);
    }
  });

  return requiredWarningCode;
}

function WeatherWarning() {
  const [requiredWarningCodeList, setRequiredWarningCodeList] = useState<
    Array<string>
  >([]);

  async function getFetchForcastInfomation() {
    await getWeatherWarning()
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        let keyFatchResult: Array<string> = KeyFatch(data);
        setRequiredWarningCodeList(keyFatchResult);
      })
      .catch((error) => {
        console.log(error);
        setRequiredWarningCodeList([]);
      });
  }

  useEffect(() => {
    getFetchForcastInfomation();
  }, []);

  if (
    requiredWarningCodeList?.length !== 0 &&
    requiredWarningCodeList !== null
  ) {
    return (
      <Container>
        <div id="weatherWarningBox">
          <div id="weatherWarningBox_Title">現時天文台天氣警告</div>

          <div id="weatherWarningBox_icons">
            {requiredWarningCodeList.map((item) => WarningIcon(item))}
          </div>
        </div>
      </Container>
    );
  } else {
    return null;
  }
}

export default WeatherWarning;
